import { defineMessages } from 'react-intl';

export const messages: {
	solutionPlanStateUpdateErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	solutionPlanStateUpdateErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	solutionPlanStateUpdateErrorTitle: {
		id: 'studio-foundations.solution-plan-state-update-listener.solution-plan-state-update-error-title',
		defaultMessage: 'Error',
		description: 'Error title for solution plan state update error',
	},
	solutionPlanStateUpdateErrorDescription: {
		id: 'studio-foundations.solution-plan-state-update-listener.solution-plan-state-update-error-description',
		defaultMessage: 'Something went wrong while updating the solution plan',
		description: 'Error description for solution plan state update error',
	},
});
